/* eslint-disable */
import { useState } from "react"
import DREColumnsContent from "./DREColumnsContent"
import DREGroup from "./DREGroup"
import { getBackgroundColor } from "./DREHelper"

const DREItem = ({ item }) => {
  const [collapsed, setCollapsed] = useState(true)
  const fullName = `${item.classification} - ${item.name}`
  const hasChildren = item.children.length ? true : false
  const isPercent = item.format && item.format === 'percent' ? true : false

  return (
    <div>
      <DREColumnsContent
        name={fullName}
        values={item.values}
        total={item.total}
        canExpand={hasChildren}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        isPercent={isPercent}
        backgroundColor={getBackgroundColor(item)}
      />

      {!collapsed && item.children?.map((group) => (
        <DREGroup key={group.classification} group={group} />
      ))}
    </div>
  )
}

export default DREItem